module.exports = __webpack_public_path__ + "static/img/cn.b2d74d88.png";